import { defineComponent, computed } from "vue";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "input-wrapper",
  props: {
    label: { default: void 0 },
    labelClass: { default: void 0 },
    id: { default: void 0 },
    errorMessage: { default: void 0 },
    inlineLabel: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    showLabel: { type: Boolean, default: false },
    medium: { type: Boolean, default: false },
    large: { type: Boolean, default: false },
    hasFixedValue: { type: Boolean, default: false },
    value: { default: void 0 }
  },
  setup(__props, { expose }) {
    const props = __props;
    const hasError = computed(() => !!props.errorMessage);
    const hasValue = computed(
      () => props.value !== void 0 && props.value !== null && props.value !== ""
    );
    const wrapperClass = computed(() => {
      const classes = [];
      if (hasError.value) {
        classes.push("input-wrapper--error");
      }
      if (props.disabled) {
        classes.push("input-wrapper--disabled");
      }
      if (props.readonly) {
        classes.push("input-wrapper--readonly");
      }
      if (props.medium) {
        classes.push("input-wrapper--inline-label input-wrapper--medium");
      } else if (props.large) {
        classes.push("input-wrapper--inline-label input-wrapper--large");
      } else if (props.inlineLabel) {
        classes.push("input-wrapper--inline-label");
      }
      if (hasValue.value || props.hasFixedValue) {
        classes.push("input-wrapper--has-value");
      }
      return classes;
    });
    expose({ wrapperClass, hasError });
    return { __sfc: true, props, hasError, hasValue, wrapperClass };
  }
});
export {
  _sfc_main as default
};
